import React from 'react'

export default function ModalImage({ src }) {
  return <img src={src} id="modal_img" alt="puni_kvadar" />
}
